import { Td, Tr } from "@chakra-ui/react";

export default function TableListHelper(props: any) {
  const lista = props.data;
  const text = props.text;
  const idBandeira = props.id;
  const tipo = props.type;

  const taxas = lista.filter((item: any) => item.idBandeira === idBandeira);

  // console.log(`taxas da bandeira: ${text}`, taxas);

  if (tipo === "Credito") {
    return (
      <Tr key={idBandeira}>
        <Td fontSize={"12px"}>{text}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[0]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[1]?.percentual ? taxas[1]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[2]?.percentual ? taxas[2]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[3]?.percentual ? taxas[3]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[4]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[5]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[6]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[7]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[8]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[9]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[10]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[11]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[12]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[13]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[14]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[15]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[16]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[17]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[18]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[19]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[20]?.percentual : 0
        } %`}</Td>
      </Tr>
    );
  } else if (tipo === "Debito") {
    return (
      <Tr key={idBandeira}>
        <Td fontSize={"12px"}>{text}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[0]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
        <Td fontSize={"12px"}>{"0 %"}</Td>
      </Tr>
    );
  } else if (tipo === "DebitoCredito") {
    return (
      <Tr key={idBandeira}>
        <Td fontSize={"12px"}>{text}</Td>

        <Td fontSize={"12px"}>{`${
          taxas[24]?.percentual ? taxas[24]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[0]?.percentual ? taxas[0]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[1]?.percentual ? taxas[1]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[2]?.percentual ? taxas[2]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[3]?.percentual ? taxas[3]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[4]?.percentual ? taxas[4]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[5]?.percentual ? taxas[5]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[6]?.percentual ? taxas[6]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[7]?.percentual ? taxas[7]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[8]?.percentual ? taxas[8]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[9]?.percentual ? taxas[9]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[10]?.percentual ? taxas[10]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[11]?.percentual ? taxas[11]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[12]?.percentual ? taxas[12]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[13]?.percentual ? taxas[13]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[14]?.percentual ? taxas[14]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[15]?.percentual ? taxas[15]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[16]?.percentual ? taxas[16]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[17]?.percentual ? taxas[17]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[18]?.percentual ? taxas[18]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[19]?.percentual ? taxas[19]?.percentual : 0
        } %`}</Td>
        <Td fontSize={"12px"}>{`${
          taxas[20]?.percentual ? taxas[20]?.percentual : 0
        } %`}</Td>
      </Tr>
    );
  } else {
    return <></>;
  }
}
